import { createSlice } from "@reduxjs/toolkit";
import { getFaculty, getFacultyDetails, getFacultyTimetable } from "../../builders/faculty/faculty.builder";
import { createFaculty } from "../../builders/addFaculty/add-faculty.builder";
const initialState = {
    loading: false,
    facultyData: [],
    facultyDetailsData: [],
    facultyTimetableData: [],
};

const facultySlice = createSlice({
    name: "faculty",
    initialState,
    reducers: {

        clearFacultyDetailsdata : (state)=>{
            state.facultyDetailsData = []
        },
       
        clearExtraReducers  : (state) =>{
           state.loading = false,
           state.facultyData = []
           state.facultyDetailsData = []
           state.facultyTimetableData = []
          },
      },
    extraReducers: (builder) => {
    
        builder.addCase(getFaculty.pending, (state) => {
            state.loading = true
        });
        builder.addCase(getFaculty.fulfilled, (state, action) => {
            state.loading = false
            state.facultyData = action.payload

        });
        builder.addCase(getFaculty.rejected, (state) => {
            state.loading = false
        });

        builder.addCase(createFaculty.pending, (state) => {
            state.loading = true
        });
        builder.addCase(createFaculty.fulfilled, (state, action) => {
            state.loading = false
            state.facultyData = action.payload

        });
        builder.addCase(createFaculty.rejected, (state) => {
            state.loading = false
        });

        builder.addCase(getFacultyDetails.pending, (state) => {
            state.loading = true
        });
        builder.addCase(getFacultyDetails.fulfilled, (state, action) => {
            state.loading = false
            state.facultyDetailsData = action.payload

        });
        builder.addCase(getFacultyDetails.rejected, (state) => {
            state.loading = false
        });


        builder.addCase(getFacultyTimetable.pending, (state) => {
            state.loading = true
        })
        builder.addCase(getFacultyTimetable.fulfilled, (state, action) => {
            state.facultyTimetableData = action.payload
            state.loading = false
        })
        builder.addCase(getFacultyTimetable.rejected, (state) => {
            state.loading = false
        })
    },
});


export default facultySlice.reducer;
